// modules/SiteDownloads.js
import React                from 'react';
import $                    from 'jquery';
import SiteDownloadButton   from './SiteDownloadButton';

const sources = require('../config.json');

class SiteDownloads extends React.Component {
	constructor(props) {
		super(props);
		var d = new Date();
		this.downloads_url = sources.sitedownloads + "?ts=" + d.getTime();

		this.state = {
			data: {
				downloads: []
			},
		};

		this.receivedDownloadData = this.receivedDownloadData.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.downloads_url,dataType:'json'}).done(this.receivedDownloadData);
	}

	receivedDownloadData(data, status, xhr) {
		let newState = Object.assign(this.state, {
			data: data
		});

		this.setState(newState);
	}

	eachDownloadButton(download) {
		if (download.length !== 0) {
			return (
				<SiteDownloadButton
					key={download.id}
					buttonlink={download.link}>
					{download.title}
				</SiteDownloadButton>
			)
		}
	}

	render() {
		if (this.state.data.downloads.length !== 0) {
			return (
				<div className={this.props.divClass}>
					<div className="w-100 w-30-lg fl-lg ">
						<p className="m-b-0 small-blue-font tc tl-lg">Windermere Downloads</p>
					</div>
					<div className="w-100 w-70-lg fr-lg">
						<div className="cf">
                				{this.state.data.downloads.map(this.eachDownloadButton)}
						</div>
					</div>
				</div>
			);
		} else {
			return(<div></div>);
		}
	}
}

export default SiteDownloads;


/** WEBPACK FOOTER **
 ** ./src/modules/common/SiteDownloads.js
 **/